class ViblastLoader {
  constructor() {
    this._enabled = false;
    this.Viblast = null;
    this._calls = [];
  }

  // asyncronously download the viblast code
  load(code, sourceUrl) {
    if (this._enabled) { return; }
    this._sourceUrl = sourceUrl;
    this._enabled = true;
    const el = document.createElement('script');
    el.type = 'text/javascript';
    el.async = 'async';
    el.onload = this._onLoad.bind(this);
    el.src = '//cdn.viblast.com/vb/6.57/viblast.js';
    document.getElementsByTagName('head')[0].appendChild(el);
  }

  refresh() {
    this._calls.push(['refresh']);
    this._flush();
  }

  onRender() {
    // this._calls.push(['addEventListener', 'addthis.layer.rendered', callback]);
    this._flush();
  }

  // called when the script tag finishes downloading
  _onLoad() {
    this.Viblast = window.viblast;
    this._flush();
  }

  // flushes calls to addthis that may have been queued up while the
  // script loads
  _flush() {
    // if (this._enabled && !this.Viblast) { return; }
    // const calls = this._calls;
    // this._calls = [];
    // if (!this._enabled) { return; }

    // calls.forEach((args) => {
    //   const method = args.shift();
    //   if (method === 'refresh') {
    //     this.Viblast.layers.refresh();
    //   } else {
    //     this.Viblast[method].apply(this.Viblast, args);
    //   }
    // });
  }
}


export default new ViblastLoader();



// WEBPACK FOOTER //
// ./src/viblast_loader.js